import { generatePath } from 'react-router';
import get from 'lodash/get';
import { noCache } from '@Utils/Network';
import Register from '@Services/Register';
import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';
import { updateDialog, closeDialog } from '@Containers/Dialogs/DialogsActions';
import { loginSetDataReducerType } from '@Pages/Login/LoginConstants';
import { setData as setRegisterData } from '@Pages/Login/Register/RegisterActions';
import { showInfoToastMessage } from '@Containers/ToastMessages/InfoToastMessage/InfoToastMessageActions';
import { showChangedToastMessage } from '@Containers/ToastMessages/ChangedToastMessage/ChangedToastMessageActions';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import { typeOfBulkIdRegisterModal, SET_STATUS, BulkIdRegisterModalStatus } from './constants';
import { isFinished as isFinishedSelector } from './selectors';

// Basically duplicate of LoginActions -> setData to prevent circular dependencies import...
function setLoginData(data) {
  return {
    type: loginSetDataReducerType,
    payload: data,
  };
}

export function openBulkIdRegisterModal(props) {
  return (dispatch) => {
    dispatch(
      updateDialog({
        id: typeOfBulkIdRegisterModal,
        dialogType: typeOfBulkIdRegisterModal,
        ...props,
      })
    );
  };
}

export function closeBulkIdRegisterModal() {
  return (dispatch) => {
    dispatch(
      closeDialog({
        id: typeOfBulkIdRegisterModal,
      })
    );
  };
}

export const bulkIdSubmit = (data) => (dispatch) =>
  MessageBroker.send(
    RequestUrls.validateBulkId,
    {
      id: data.bulkId,
      password: data.bulkPassword,
    },
    { Authorization: false }
  ).then((response) => {
    if (response.success) {
      Register.setData(data);
      dispatch(openBulkIdRegisterModal({ actPathDesc: response.actPathDesc }));
    }
    return response;
  });

export const setStatus = (status) => ({
  type: SET_STATUS,
  payload: status,
});

export const emailSubmit = (email) => async (dispatch) => {
  try {
    dispatch(setStatus(BulkIdRegisterModalStatus.LOADING));
    await MessageBroker.send(
      RequestUrls.emailExists,
      { email },
      {
        ...noCache(),
      }
    );
    dispatch(setStatus(BulkIdRegisterModalStatus.SUCCESS));
    dispatch(
      showChangedToastMessage({
        title: 'You already have a profile with other Elsevier products',
        content: 'Use your existing email and password to access Reaxys.',
      })
    );
    dispatch(closeBulkIdRegisterModal());
    dispatch(setLoginData({ username: email, password: '' }));
    history.push({
      pathname: generatePath(paths.LOGIN),
    });
  } catch (error) {
    if (get(error, 'status') === 404) {
      // Email not found
      dispatch(setStatus(BulkIdRegisterModalStatus.NOT_FOUND));
      dispatch(
        showInfoToastMessage({
          title: 'Register to access Reaxys',
          content: 'Use your email address and create a password to complete the registration process.',
        })
      );
      dispatch(closeBulkIdRegisterModal());
      dispatch(setRegisterData({ email }));
      history.push({
        pathname: paths.REGISTER,
      });
    } else {
      // Another error
      dispatch(setStatus(BulkIdRegisterModalStatus.ERROR));
      Logger.error(error);
    }
  }
};

export const onModalClosed = () => (dispatch, getState) => {
  const isFinished = isFinishedSelector(getState());

  if (!isFinished) {
    Register.clear();
  }
  dispatch(setStatus(BulkIdRegisterModalStatus.INITIAL));
};
